// Костыльный файл, избавляемся от цикла, так как тут импортится store
import { IS_MY_TEAM, IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { changeHomeHistory } from 'reactApp/modules/home/home.actions';
import { changeHistory } from 'reactApp/modules/router/router.module';
import { getCurrentRouteId } from 'reactApp/modules/router/router.selectors';
import { changeSearchHistory } from 'reactApp/modules/search/search.actions';
import { isIntegrationStorage } from 'reactApp/modules/storage/storage.helpers';
import { store as reduxStore } from 'reactApp/store';
import opener from 'reactApp/utils/opener';
import { getEncodePath } from 'reactApp/utils/urlHelper';

import { EStorageType } from './storage.types';

let lastId = '';

// выпилить navigateStorage когда будет нормальный хелпер
export const changeStorageHistory = ({
    id,
    storage,
    navigateToStorage,
    search = '',
}: {
    id?: string;
    search?: string;
    isFolder?: boolean;
    storage?: EStorageType;
    navigateToStorage?: EStorageType;
}) => {
    if ((storage === EStorageType.home || isIntegrationStorage(storage)) && id) {
        const currentId = getCurrentRouteId(reduxStore.getState());

        // Если инлайн интеграция (Тутория), то позволяем перемещаться по папкам даже если lastId === id,
        // потому что существующая логика блокирует переход в папку, из которой только что переместились на уровень выше
        // посредством хлебных крошек, т.к. они не обновляют последний айди.
        // https://jira.vk.team/browse/TUTR-223
        if (storage === EStorageType.inlineIntegration || lastId !== id || currentId !== id) {
            reduxStore.dispatch(changeHomeHistory({ id, search }));
        }
        lastId = id;
        return;
    }

    if (storage === EStorageType.search && id) {
        reduxStore.dispatch(changeSearchHistory({ id }));
        return;
    }

    if (IS_PHONE_BROWSER && (storage === EStorageType.public || storage === EStorageType.stock) && id) {
        reduxStore.dispatch(changeHistory(`/${storage}/${getEncodePath(id)}`));
        return;
    }

    if (navigateToStorage) {
        const url = new URL(`/${navigateToStorage}${id || ''}`, document.location.origin);

        if (IS_MY_TEAM) {
            url.searchParams.append('wv', '1');
        }
        opener(url.href, true);
    }
};
